import React from 'react';

import FiltersContext from './context';

const useFilters = () => React.useContext(FiltersContext);

export default useFilters;
